<template>
    <v-card class="recharge-card p-relative">
        <v-progress-linear v-if="loading" active value="0" indeterminate absolute top color="primary" :height="pcOnly ? 2 : 2" ></v-progress-linear>

        <v-card-title class="mb-1">
            <v-icon size="26" color="strong-text" class="me-2">mdi-wallet-plus</v-icon>
            شحن المحفظة
        </v-card-title>

        <v-card-text class="pt-3" style="overflow-x: hidden;" :class="{'px-3': phoneOnly}">
            <transition :name="step === 1 ? 'slide-left' : 'slide-right'" mode="out-in">
                <div v-if="step === 0" key="0" :class="{'d-flex flex-column fill-height': phoneOnly}">
                    <v-fade-transition>
                        <v-form v-if="paymentMethod !== 'recharge_card'" @submit.prevent class="mb-4">
                            <v-text-field prepend-inner-icon="mdi-cash" color="primary" :disabled="loading" :min="minAmount" type="number" label="مبلغ الشحن" placeholder="أدخل المبلغ المراد شحنه" hide-details flat v-model="amount" outlined class="mb-2" /> <!-- step="any" -->
                        </v-form>
                    </v-fade-transition>

                    <v-list class="choose-payment-method py-0 mb-4">
                        <v-list-item v-for="method in paymentMethods" :key="method.value" :class="{'v-list-item--active': paymentMethod === method.value, [`${method.color.split(' ')[0]}--text`]: paymentMethod === method.value}" class="payment-method-item rounded py-1 mb-2 overflow-hidden" v-ripple="phoneOnly" @click="paymentMethod = method.value" style="border: 1px solid;" :style="paymentMethod !== method.value ? 'border-color: rgba(0,0,0, .15)' : ''">
                            <v-list-item-icon class="me-3 my-auto py-2">
                                <!-- <v-radio v-model="paymentMethod" :color="method.color || 'primary'" :value="method.value" /> -->
                                <v-btn icon :color="paymentMethod === method.value ? method.color : 'text'" style="margin-top: -4px">
                                        <svg v-if="paymentMethod === method.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z"></path></svg>
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"></path></svg>
                                </v-btn>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="mb-0 d-flex align-center" style="line-height: 0!important;">
                                    <img v-if="method.img" :src="method.img" :style="`height: ${method.height || 30}px; max-height: 35px; width: auto`" />
                                    <v-icon v-else-if="method.icon" size="28" :color="method.color || 'primary'" class="ms-1">{{method.icon}}</v-icon>

                                    <div v-if="method.iconLabel" class="medium-text strong-text--text ms-3">{{method.iconLabel}}</div>
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="method.subtitle" class="details-text mt-1" style="line-height: 1.4!important">{{method.subtitle}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>


                        <v-alert v-if="hasWebOnlyMethods" type="info" color="indigo" outlined dense icon="mdi-web" class="mt-5" v-ripple @click.prevent="openWebWallet">
                            <div class="medium-text">
                                ندعم وسائل دفع أخرى عبر
                                <a class="indigo--text text--darken-1" href="" @click.prevent="openWebWallet">منصة الويب</a>

                                <v-icon color="indigo" class="ms-2">mdi-chevron-left</v-icon>
                            </div>
                        </v-alert>
                    </v-list>

                    <div class="w-100 mt-auto mt-md-4">
                        <v-btn depressed block :large="phoneOnly" color="primary" :disabled="(!amount && paymentMethod !== 'recharge_card') || !paymentMethod" @click="nextStep">
                            <span>الخطوة التالية</span>
                            <v-icon right style="opacity: 0.75">mdi-chevron-left</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div v-else-if="step === 1" key="1">
                    <div class="payment-gateway-buttons">
                        <recharge-card-checkout v-if="paymentMethod === 'recharge_card'" @done="paymentDone" />
                        <mobile-wallets-checkout v-if="paymentMethod === 'mobile_wallets'" :amount="amount" @done="paymentDone" />
                        <paymob-card-checkout v-else-if="paymentMethod === 'paymob_card'" :amount="amount" @done="paymentDone" />
                        <paymob-mobile-wallet-checkout v-else-if="paymentMethod === 'paymob_mobile_wallets'" :amount="amount" @done="paymentDone" />
                        <manual-external-checkout v-else-if="paymentMethod === 'manual_external_payments'" :amount="amount" @done="paymentDone" />
                        <paymob-kiosk-checkout v-else-if="paymentMethod === 'paymob_kiosk'" :amount="amount" @done="paymentDone" />
                        <paymob-valu-checkout v-else-if="paymentMethod === 'paymob_valu'" :amount="amount" @done="paymentDone" />
                        <fawry-checkout v-else-if="paymentMethod === 'fawry' || paymentMethod === 'fawry_staging'" :amount="amount" :staging="paymentMethod === 'fawry_staging'" @done="paymentDone" />
                        <shakeout-checkout v-else-if="paymentMethod === 'shakeout'" :amount="amount" @done="paymentDone" />
                        <fawaterk-checkout v-else-if="paymentMethod === 'fawaterk'" :amount="amount" @done="paymentDone" />
                    </div>
                    <div class="w-100 mt-auto mt-md-1">
                        <v-btn text color="muted" block depressed @click="step = 0">
                            <v-icon left style="opacity: 0.75">mdi-chevron-right</v-icon>
                            <span>العودة للخلف</span>
                        </v-btn>
                    </div>

                </div>
            </transition>

            <v-btn icon absolute top left :disabled="loading" @click="close">
                <v-icon>{{pcOnly ? 'mdi-close' : 'mdi-arrow-left'}}</v-icon>
            </v-btn>

        </v-card-text>
        <!-- <v-card-actions class="pt-0 px-6 pb-4">
            <v-spacer></v-spacer>
        </v-card-actions> -->
    </v-card>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import MobileWalletsCheckout from './mobile-wallets-checkout'
import RechargeCardCheckout from './recharge-card-checkout'
import PaymobCardCheckout from './paymob-card-checkout'
import PaymobMobileWalletCheckout from './paymob-mobile-wallet-checkout'
import PaymobKioskCheckout from './paymob-kiosk-checkout'
import PaymobValuCheckout from './paymob-valu-checkout'
import ShakeoutCheckout from './shakeout-checkout'
import FawaterkCheckout from './fawaterk-checkout'
import ManualExternalCheckout from './manual-external-checkout'
export default {
    props: {
        wallet: {}
    },
    components: {
        MobileWalletsCheckout,
        PaymobCardCheckout,
        PaymobMobileWalletCheckout,
        PaymobKioskCheckout,
        ManualExternalCheckout,
        // Lazy: keep Fawry JS/CSS out of the initial app bundle
        FawryCheckout: () => import(/* webpackChunkName: "fawry-checkout" */ './fawry-checkout'),
        ShakeoutCheckout,
        FawaterkCheckout,
        PaymobValuCheckout,
        RechargeCardCheckout
    },
    data(){
        return {
            loading: false,

            amount: '',
            paymentMethod: '',
            
            step: 0,

        }
    },
    computed: {
        ...GlobalComputed,
        appRechargeInfo(){
            return this.appData ? this.appData.recharge_info : {};
        },
        minAmount(){
            return this.appRechargeInfo.min_recharge_amount;
        },
        paymentMethods(){
            const appRechargeInfo = this.appRechargeInfo;
            const supportedMethods = appRechargeInfo ? appRechargeInfo.supported_methods : [];
            const allMethods = [
                {
                    value: 'recharge_card',
                    title: 'كود بطاقة الشحن',
                    // subtitle: 'الدفع بفودافون كاش ومحافظ الجوال اﻷخرى',
                    img: '/img/recharge-card.png',
                    color: 'indigo darken-2',
                    iconLabel: 'كود بطاقة الشحن',
                    height: 32,
                },
                {
                    value: 'mobile_wallets',
                    title: 'محافظ الجوال',
                    subtitle: 'الدفع بفودافون كاش ومحافظ الجوال اﻷخرى',
                    img: '/img/mobile-wallets.png',
                    color: 'error',

                },
                {
                    value: 'paymob_card',
                    title: 'البطاقات البنكية',
                    img: '/img/paymob-cards.png',
                    color: 'indigo darken-3',
                    height: 31,
                },
                {
                    value: 'paymob_mobile_wallets',
                    title: 'محافظ الجوال',
                    img: '/img/mobile-wallets.png',
                    color: 'error',
                },
                {
                    value: 'paymob_kiosk',
                    title: 'أمان',
                    img: '/img/paymob-kiosk.png',
                    color: 'blue darken-1',
                },
                {
                    value: 'paymob_valu',
                    title: 'ValU',
                    // subtitle: 'التقسيط عبر ValU',
                    img: '/img/valU.svg',
                    color: 'teal darken-1',
                    height: 24,
                },
                {
                    value: 'fawry',
                    title: 'فوري',
                    img: '/img/fawry-logo.png',
                    color: 'amber darken-3',
                },
                {
                    value: 'fawry_staging',
                    title: 'فوري (تجريبي)',
                    img: '/img/fawry-logo.png',
                    color: 'amber darken-3',
                },
                {
                    value: 'shakeout',
                    title: 'فوري',
                    img: '/img/fawry-logo.png',
                    color: 'teal darken-2',
                },
                {
                    value: 'fawaterk',
                    title: 'فوري / فواتيرك',
                    img: '/img/fawaterak.png',
                    color: 'blue darken-4',
                    height: 28,
                },
                {
                    value: 'manual_external_payments',
                    icon: 'mdi-wallet-plus',
                    title: appRechargeInfo ? appRechargeInfo.manual_external_payments_label : 'الدفع الخارجي',
                    iconLabel: appRechargeInfo ? appRechargeInfo.manual_external_payments_label : 'الدفع الخارجي',
                    color: 'primary',
                },
            ];

            let methods = [];
            if (supportedMethods){
                supportedMethods.forEach(method=>{
                    const methodItem = allMethods.find(m=>m.value === method);
                    if (methodItem){
                        methods.push(methodItem);
                    }
                });
            }
            const webMethods = ['paymob_valu', 'paymob_card', 'paymob_kiosk', 'paymob_mobile_wallets', 'fawry', 'fawry_staging', 'shakeout'];

            if (this.capRunning){
                return methods.filter(method=>!webMethods.includes(method.value));
            }else{
                return methods;
            }
        },
        hasWebOnlyMethods(){
            const webMethods = ['paymob_valu', 'paymob_card', 'paymob_kiosk', 'paymob_mobile_wallets', 'fawry', 'fawry_staging', 'shakeout'];
            const supportedMethods = this.appRechargeInfo ? this.appRechargeInfo.supported_methods : [];

            return this.capRunning && supportedMethods.some(method=>{return webMethods.includes(method)});
        },
    },
    methods: {
        ...GlobalMethods,
        close(){
            this.$emit('close', true);
        },
        openWebWallet(){
            const web_url = process.env.VUE_APP_WEB_APP_URL;
            let token = window.localStorage.getItem('tK');
            token = token.split('').reverse().join('');
            let query = '';
            for (let key in this.$route.query){
                if (query) query += '|';
                query += `${key}:${this.$route.query[key]}`;
            }
            window.open(`${web_url}/login?from=app&tk=${token}&to=w&q=${query}`, '_system');
        },
        paymentDone(noReload=false){
            this.close();
            window.setTimeout(()=>{
                this.step = 0;
                this.amount = '';
                this.paymentMethod = '';
            }, 500);
            
            if (!noReload){
                window.setTimeout(()=>{
                    this.$emit('reload-data');
                }, 500);
            }
        },
        action(){

        },
        nextStep(){
            if (this.paymentMethod === 'recharge_card'){
                this.step = 1;
            }else{
                if (this.amount && this.paymentMethod){
                    if (parseFloat(this.amount) >= this.minAmount){
                        this.step = 1;
                        
                    }else{
                        this.showMsg(`أقل مبلغ للشحن هو ${this.minAmount} جنيه`, 'warning');
                    }
                }
            }
        },
    },
    mounted(){
        window.setTimeout(()=>{
            if (this.paymentMethods.length === 1){
                this.paymentMethod = this.paymentMethods[0].value;
            }

            if (this.$route.query && this.$route.query.recharge){
                this.amount = this.$route.query.recharge;
            }
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
.recharge-card{
    transition: 0.2s ease all;
}
.payment-method-item{
    &.v-list-item--active{
        &::before{
            opacity: 0.06!important;
        }
    }
}
</style>